// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","737":"fb7d5399","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"a89a9c3dc6b06d567bf7","737":"f5c7607383d5158e723c","883":"7fe93472f3fd22c42c4f","972":"28a86500866b6b743622"}[chunkId] + ".js";
};